import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useMsal } from "@azure/msal-react";
import { Sidebar } from './Sidebar';

export function Layout() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar_collapsed');
    return saved ? JSON.parse(saved) : false;
  });
  const { instance, accounts } = useMsal();

  useEffect(() => {
    localStorage.setItem('sidebar_collapsed', JSON.stringify(isCollapsed));
  }, [isCollapsed]);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleLogout = () => {
    instance.logoutRedirect({ postLogoutRedirectUri: "/" });
  };
  
  return (
    <div className="flex h-screen w-full bg-slate-50 dark:bg-background-dark overflow-hidden">
      <Sidebar isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
      <main className="flex-1 flex flex-col h-full overflow-hidden relative transition-all duration-300">
        <Outlet />
      </main>
    </div>
  );
}